import { makeSx } from '../../../theme/_utils'
import { defaultPalette } from '../../../theme/idsTheme'

export default makeSx({
    fullScreenActionDialogHeader: {
        position: 'fixed',
        top: 0,
        right: 0,
        left: 0,
        width: '100%',
        padding: '.75rem 1rem',
        boxShadow: `0px 2px 4px 0px rgba(221, 225, 236, 0.25), 0px 5px 15px 0px ${defaultPalette.lightGrey.harder}`,
        backgroundColor: defaultPalette.white.main,
    },
    fullScreenActionDialogHeaderTitle: {
        fontSize: '1.25rem',
        fontWeight: 700,
        color: defaultPalette.typography.main,
    },
    fullScreenActionDialogHeaderTitleSkeleton: {
        width: '50%',
        fontSize: '1.25rem',
    },
})
